//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import adres from '~/graphql/queries/adres.gql';
import uniqueEmailCheck from '~/graphql/queries/uniqueEmailCheck.gql';

export default {
  name: 'Stap1',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data: () => ({
    errors: {
      e_mailadres: '',
      address: '',
    },
  }),
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    getAddress() {
      this.$nextTick(async function () {
        if (this.formData.huisnummer && this.formData.postcode && this.formData.postcode.length === 6) {
          await this.$apollo.query({
            query: adres,
            variables: {
              postcode: this.formData.postcode,
              huisnummer: this.formData.huisnummer,
            },
          }).then((data) => {
            if (data?.data?.adres) {
              const adres = data.data.adres;
              const newFormData = JSON.parse(JSON.stringify(this.formData));
              newFormData.adres = adres?.straat ? adres.straat : '';
              newFormData.plaats = adres?.plaats ? adres.plaats : '';
              this.$emit('setFormData', newFormData);

              this.errors.address = (!newFormData.adres || !newFormData.plaats) ? 'Adres niet gevonden' : '';
            }
          }).catch((err) => {
            console.error(err);
          });
        }
      });
    },
    async next(data) {
      if (!this.formData?.e_mailadres) {
        return;
      }

      await this.$apollo.query({
        query: uniqueEmailCheck,
        variables: {
          email: this.formData.e_mailadres,
        },
      }).then((data) => {
        if (data.data.uniqueEmailCheck) {
          this.$emit('submit', data);
        } else {
          this.errors.e_mailadres = ['Dit e-mailadres wordt al gebruikt'];
        }
      });
    },
    emailChanged() {
      this.errors.e_mailadres = [];
    },
  },
};
